export enum PeopleInAssetsColors {
  // Text Colors
  DarkText = '#4a4a4a',
  MediumText = '#8a8a8a',
  Neutral700 = '#353a4a',
  MutedLabel = '#878dab',

  // Background Colors
  White = '#fff',
  LightGrayBackground = '#f5f5f5',
  HighlightBackground = '#eef0f6',

  // Border Colors
  LightBorder = '#c6c8cf',

  // Shadow Colors
  BoxShadow = 'rgba(0, 0, 0, 0.1)',
}

export type PeopleInAssetsColorKey = keyof typeof PeopleInAssetsColors;
